const prefixUrl = (url: string, defaultPrefix = 'https'): string => {
  let prefix = `${defaultPrefix}:`

  if (!url) {
    return url
  }

  if (url.startsWith('http')) {
    return url
  }

  if (!url.startsWith('//')) {
    prefix = `${prefix}//`
  }

  return prefix + url
}

export default prefixUrl
